import Api from './api';

const HistoricosService = {
    index: () => Api.get('/historicos'),
    historicos_sinistros: () => Api.get(`/historicos/sinistros`),
    delete: async (id) => await Api.delete(`/historicos/${id}`)
}

export default HistoricosService;